import React from "react";
import { Link } from "react-router-dom";

import Navigator from "../Elements/Navigator";
import MenuFunctionIcons from "../Elements/MenuFunctionIcons";
import { renderContainer } from "../../../common/utils";
import logo from "../../../assets/images/logo/logolariales.png";

export default function MenuOne({ container }) {
  return (
    <div className="menu -style-1">
      <div className={renderContainer(container)}>
        <div className="menu__wrapper">
          <Link to="/">
            <a className="menu__wrapper__logo">
              <img src={logo} alt="Logo" />
            </a>
          </Link>
          <Navigator />
          <MenuFunctionIcons />
        </div>
      </div>
    </div>
  );
}
